<template>
  <div>
    <p>{{ $t('serviceMessages.user_account_inactive') }}</p>
    <div v-if="user.subscription === 'extensive'">
      {{ $t('serviceMessages.inactive_contact_us') }}
    </div>
    <div v-else-if="userPayments.length > 0">
      <a
        v-if="userPayments[0].status === 'open'"
        :href="userPayments[0].paymentUrl"
      >
        {{ $('message.pay_with_mollie_link') }}
      </a>
      <p v-else-if="userPayments[0].status === 'pending'">
        {{ $t('message.payment_status_pending') }}<br>
        {{ $t('message.payment_pending_text') }}
      </p>
      <div v-else>
        <p class="error--text font-weight-bold">
          {{
            $t('message.payment_status', {
              status: $t('message.payment_status_' + userPayments[0].status),
            })
          }}
        </p>
        <p>{{ $t('message.problem_with_payment') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Activate',
  data() {
    return {
      refreshUserInterval: -1,
    }
  },
  computed: {
    ...mapState(['user', 'userPayments']),
  },

  created() {
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
      case 'onOwnUserUpdated':
        if (mutation.payload.active === true) {
          this.$router.replace({ name: 'dashboard' })
        }
        break
      }
    })
  },
  mounted() {
    this.refreshUserInterval = setInterval(
      () => this.$store.dispatch('reloadUser'),
      15000
    )
    if (this.user.active) {
      this.$router.replace({ name: 'dashboard' })
    }
    this.$store.dispatch('getUserPayments', {
      query: { status: 'all', $sort: { createdAt: -1 } },
    })
  },
  beforeDestroy() {
    clearInterval(this.refreshUserInterval)
  },
}
</script>

<style scoped></style>
